var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnstar3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93166 15.5416L5.40666 13.4833C5.515 13 5.32333 12.325 4.97333 11.975L2.90666 9.90828C1.69 8.69162 2.08166 7.45828 3.78166 7.17495L6.44 6.73328C6.88166 6.65828 7.415 6.26662 7.615 5.85828L9.08166 2.92495C9.87333 1.33328 11.1733 1.33328 11.9733 2.92495L13.44 5.85828C13.5317 6.04995 13.7067 6.23328 13.8983 6.39162",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2815 7.17505C18.9815 7.45838 19.3815 8.69172 18.1565 9.90838L16.0898 11.975C15.7398 12.325 15.5482 13 15.6565 13.4834L16.2482 16.0417C16.7148 18.0667 15.6398 18.85 13.8482 17.7917L11.3565 16.3167C10.9065 16.05 10.1648 16.05 9.70651 16.3167L7.21484 17.7917",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8639 1.66663L2.19727 18.3333",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnstar3);
export default __webpack_public_path__ + "static/media/unstar (3).3cbb7229a68d343e6d0c77888416b748.svg";
export { ForwardRef as ReactComponent };